import React from 'react'
import { useTranslation } from 'react-i18next'
import { path } from 'ramda'
import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { stocksClient } from '../../../../utils/apollo/api'
import { useRowActionsColumn } from '../../../../components/tables/Table'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import ListCounter from '../../../../components/helpers/ListCounter'
import Text from '../../../../packages/kiti/components/presentation/Text'
import { useStockItems } from '../_load/StockItemsLoader'
import { useRowsActions } from './_actions/rowsActions'
import SwitchDisabled from '../../../../components/helpers/disabled/SwitchDisabled'
import Badge from '../../../../packages/kiti/components/presentation/Badge'
import Tooltip from '../../../../components/helpers/Tooltip'
import Avatar from '../../../../components/presentation/Avatar'
import FlexGrid from '../../../../components/structure/FlexGrid'
import Link from '../../../../components/actions/Link'
import { useOpenStockItemDetailModal } from '../../../../utils/routes/modals/modalsActions'
import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'

const StocksTable = () => {
  const { t } = useTranslation('listStocks')
  const stock = useStockItems()
  const openStockItemDetailModal = useOpenStockItemDetailModal()

  const colorRules = value => {
    const { amount, warningAmount, criticalAmount } = value
    if (!warningAmount || !criticalAmount) {
      return { text: t('table.status.noValues') }
    }
    if (amount <= criticalAmount) {
      return { color: 'red', text: t('table.status.critical') }
    }
    if (amount <= warningAmount) {
      return { color: 'yellow', text: t('table.status.warning') }
    }
    return { text: t('table.status.normal') }
  }

  const columns = [
    {
      label: t('table.name'),
      headerSideContent: (
        <>
          <ListCounter client={stocksClient} entity="StockItems" filterName="StockItemFilter" />
          <RefetchingIndicator />
        </>
      ),
      dataIndex: 'name',
      flex: 2,
      render: (value, record) => (
        <Link onClick={() => openStockItemDetailModal(record)} block>
          <FlexGrid justify="flex-start" gutter={0.3}>
            <Avatar name={value} image={path(['documents', 0, 'src'], record)} />
            <Text color="dark1" bold>
              {value}
            </Text>
          </FlexGrid>
        </Link>
      ),
      sortIndex: 'NAME'
    },
    {
      label: t('table.availableAmount'),
      dataIndex: 'amount',
      flex: 1,
      sortIndex: false,
      render: (value, record) => {
        const { color, text } = colorRules(record)
        return (
          <Grid justify="center">
            <Col>
              <Tooltip
                actionContent={
                  <Badge color={color}>
                    <Text color="dark1" bold>
                      {value}
                    </Text>
                  </Badge>
                }
              >
                <Text color="dark1" bold>
                  {text}
                </Text>
              </Tooltip>
            </Col>
          </Grid>
        )
      }
    },
    {
      label: t('table.totalAmount'),
      dataIndex: 'totalAmount',
      flex: 1,
      sortIndex: false,
      render: value => (
        <Text color="dark1" bold>
          {value}
        </Text>
      )
    },
    {
      label: t('table.active'),
      dataIndex: 'enabled',
      flex: 0.5,
      sortIndex: false,
      render: (_, record) => <SwitchDisabled client={stocksClient} entity="StockItem" record={record} size={'small'} />
    },

    {
      label: t('actions', { ns: 'common' }),
      flex: 0.5,
      render: useRowActionsColumn(useRowsActions)
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={stock} inPanel size="medium" />
}

export default StocksTable
